<template>
  <div class='questionnaire'>
    <div v-for="(questionInfo, index) in questionInfoList" class="question-wrapper" :key="index">
      <!-- question-title -->
      <div
        class="question-title"
        :class="questionInfo.question.type === 'LINK' && 'is-link'"
        @click="handleQuestionClick(questionInfo)"
      >
        {{ getI18nPropertyValue(questionInfo.question.name, 'cn', 'en') }}
      </div>

      <!-- answer -->
      <div v-if="questionInfo.question.type === 'STARS'" class="question-answer stars">
        <el-rate
          disabled
          :value="Number(questionInfo.answer)"
          :colors="['#0096cc', '#0096cc', '#0096cc']"
          :max="6"
        >
        </el-rate>
      </div>
      <div v-else-if="questionInfo.question.type === 'NPS'" class="question-answer nps">
        <div class="not-possible">Not possible</div>
        <div class="rating-container">
          <div
            v-for="(item, index) in Array(11)"
            class="rating-item"
            :key="index"
            :class="index === parseInt(questionInfo.answer) && 'is-active'"
          >{{ index }}</div>
        </div>
        <div class="extremely-likely">Extremely likely</div>
      </div>
      <div v-else-if="questionInfo.question.type === 'LINK'" class="question-answer">
        {{ questionInfo.answer === '1' ? $t('common.label.agreed') : $t('common.label.noAgreed') }}
      </div>
      <div v-else-if="questionInfo.question.type === 'ATTACHMENT'" class="question-answer attachment">
        <el-button
          v-loading="loading[questionInfo.id]"
          element-loading-spinner="el-icon-loading"
          class="view-btn"
          type="text"
          @click="handleAttachmentClick(questionInfo)"
        >{{ questionInfo.answer ? $t('common.btn.view') : '-' }}</el-button>
      </div>
      <div v-else-if="questionInfo.question.type === 'MULTIPLE'" class="question-answer multiple">
        <div v-for="(answer, index) in questionInfo.answer" class="answer-item" :key="index">
          {{ getI18nPropertyValue(answer.text, 'cn', 'en') }}
        </div>
      </div>
      <div v-else class="question-answer">
        {{ getAnswer(questionInfo) }}
      </div>
    </div>
  </div>
</template>

<script>
import { getI18nPropertyValue } from '@/i18n'
import { mapActions } from 'vuex'

export default {
  props: {
    questionInfoList: {
      type: Array
    }
  },
  data () {
    return {
      getI18nPropertyValue,
      loading: {}
    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    ...mapActions('common', ['getPrivateFileUrl']),
    getAnswer (questionInfo) {
      const answer = questionInfo.answer
      if (typeof answer === 'string') {
        return answer
      } else {
        return getI18nPropertyValue(questionInfo.answer.text, 'cn', 'en')
      }
    },
    handleQuestionClick (questionInfo) {
      const question = questionInfo.question
      if (question.type !== 'LINK') {
        return
      }
      let link = getI18nPropertyValue(question, 'options.0.text.cn', 'options.0.text.en')
      if (!/^https?:\/\//i.test(link)) {
        link = `https://${link}`
      }
      window.open(link)
    },
    async handleAttachmentClick (questionInfo) {
      this.$set(this.loading, questionInfo.id, true)
      const fileUrl = await this.getPrivateFileUrl({ fileType: 'COMMON_FILE', fileKey: questionInfo.answer_file_key })
      this.$set(this.loading, questionInfo.id, false)
      window.open(fileUrl)
    }
  }
}
</script>
<style lang='scss' scoped>
.questionnaire {
  .question-wrapper {
    margin-top: 30px;
    border: 1px solid #e4e7ed;
    font-size: 16px;
    color: #606266;

    .question-title {
      padding: 24px 40px;
      background-color: #fbfbfb;
      line-height: 22px;
      border-bottom: 1px solid #e4e7ed;

      &.is-link {
        color: #0096cc;
        cursor: pointer;
      }
    }

    .question-answer {
      padding: 25px 40px;
      font-size: 14px;

      &.attachment {
        .view-btn {
          ::v-deep .el-loading-mask {
            .el-loading-spinner {
              font-size: 18px;
              margin-top: -9px;
            }
          }
        }
      }

      &.stars {
        padding: 55px 40px 80px;

        .el-rate {
          height: inherit;

          ::v-deep .el-rate__icon {
            font-size: 46px;
          }
        }
      }

      &.nps {
        display: flex;
        align-items: center;
        padding: 55px 40px 80px;
        font-size: 16px;
        color: #909399;

        .not-possible {
          margin-right: 24px;
        }
        .extremely-likely {
          margin-left: 24px;
        }

        .rating-container {
          display: flex;

          .rating-item {
            padding: 8px 0;
            width: 56px;
            text-align: center;
            margin-left: 16px;
            font-size: 28px;
            font-weight: bold;
            background-color: #f1f1f1;
            border-radius: 2px;

            &:first-child {
              margin-left: 0;
            }

            &.is-active {
              color: #fff;
              background-color: #0096cc;
            }
          }
        }
      }
    }
  }
}

</style>
